
export default {
  props: {
    totalLine: {
      type: Number,
      default: 7
    },
  }
}
